import angular from 'angular';

import '../../core/main/factory/storage';
import '../../core/main/controller/environment';

angular.module("merchant.application.main").factory("merchant.application.main.factory.device", [
    "$resource", "$http",
    "core.application.main.factory.storage",
    "core.application.main.controller.environment",
    function ($resource, $http, Storage, Environment) {

        var userEndpoint = Environment.POS_API_BASE_URL + "/v1/users";
        var merchantUserAuthorizationUrl = Environment.MERCHANT_PORTAL_API_BASE_URL + "/portal/merchants/auth/sso/authorise";
        var posUserAuthorizationRedirectUrl = Environment.POS_API_BASE_URL + "/v1/auth/sso/callback?countryCode=";
        var posUserAuthorizationUrl = merchantUserAuthorizationUrl + "?redirectUrl=" + encodeURIComponent(posUserAuthorizationRedirectUrl);
        var orderEndpoint = Environment.POS_API_BASE_URL + "/v1/orders";
        var activateResource = $resource(Environment.POS_API_BASE_URL + "/v1/devices/activate");
        var tokenResource = $resource(Environment.POS_API_BASE_URL + "/v1/devices/:deviceId/token", {deviceId: "@deviceId"});

        var expose = {};

        expose.loginPosUser = function (parameters, success, error) {
            $http({
                method: "GET",
                url: userEndpoint,
                headers: {
                    "Authorization": "Bearer " + parameters.token
                }
            }).then(function (response) {
                success(response);
            }).catch(function (response) {
                error(response);
            });
        };

        expose.posUserAuthorizationUrl = function (parameters) {
            // PAYL-6876 Pass the country code to support geo steering when redirecting the in-store user
            return posUserAuthorizationUrl + (
                parameters &&
                parameters.countryCode &&
                parameters.countryCode.toLowerCase() || ""
            );
        };

        expose.activateDevice = function (parameters, success, error) {
            new activateResource(parameters).$save(success, error);
        };

        expose.retrieveToken = function (tokenErrorHandler, loginErrorHandler) {
            var parameters = {
                deviceId: expose.deviceId(),
                key: expose.deviceKey()
            };

            new tokenResource(parameters).$save(
                function (response) {
                    var token = response && response.token;
                    expose.deviceToken(token);
                    expose.loginPosUser(
                        {token: token},
                        function (response) {
                            expose.deviceName(response.data && response.data.device && response.data.device.name);
                            expose.storeName(response.data && response.data.device &&
                                response.data.device.store && response.data.device.store.name);
                        },
                        loginErrorHandler
                    );

                },
                tokenErrorHandler
            );
        };

        expose.redeemBarcode = function (parameters, deviceIdHeader, successHandler, errorHandler) {
            var data = {
                amount: parameters.amount,
                merchantReference: parameters.merchantReference,
                preApprovalCode: parameters.preApprovalCode,
                requestId: parameters.requestId,
                requestedAt: parameters.requestedAt
            };

            var headers = {
                "Operator": parameters.operator
            };
            if (deviceIdHeader) {
                headers["X-Device-Id"] = deviceIdHeader;
            } else {
                headers["Authorization"] = "Bearer " + expose.deviceToken();
            }

            $http({
                method: "POST",
                url: orderEndpoint,
                data: JSON.stringify(data),
                headers: headers
            }).then(function (response) {
                successHandler(response);
            }).catch(function (response) {
                errorHandler(response);
            });
        };

        expose.deviceKey = function (deviceKey) {
            return Storage.setLocalStorageItem("deviceKey", deviceKey);
        };

        expose.deviceId = function (deviceId) {
            return Storage.setLocalStorageItem("deviceId", deviceId);
        };

        expose.deviceName = function (deviceName) {
            return Storage.setLocalStorageItem("deviceName", deviceName);
        };

        expose.storeName = function (storeName) {
            return Storage.setLocalStorageItem("storeName", storeName);
        };

        expose.deviceToken = function (deviceToken) {
            // Should use session storage instead of local storage, to ensure
            // it's temporary, because the length of time the user can stay
            // authenticated with the device token is only 24 hours.
            return Storage.setSessionStorageItem("deviceToken", deviceToken);
        };

        return expose;

    }
]);
